import React, { useEffect, useState } from 'react';
import Paper from '@material-ui/core/Paper';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Avatar from "@material-ui/core/Avatar";
import LockOutlinedIcon from "@material-ui/icons/LockOutlined";
import { Container, Grid, makeStyles, Typography } from '@material-ui/core';
import PayPal from '../payment/paypal';
import StripePayment from "../payment/stripe"
import GooglePay from "../payment/googlePay"
import { useSelector } from 'react-redux';
import { withRouter } from 'react-router';

function Powered() {
    const styles = useStyles()
    return (
        <Container component="main" maxWidth="xs">
            {/*
            <Typography className={styles.powered} variant="body2" color="textPrimary" align="center">
                [Powered by {by}.]<br></br>
            </Typography>
            */}
            <Typography className={styles.powered} variant="body2" color="textSecondary" align="center">
                By confirming your subscription, you allow Jazzu Designer to charge you for this payment and future payments in accordance with their terms
            </Typography>
        </Container>
    );
}


const useStyles = makeStyles((theme) => ({
    paper: {
        marginTop: theme.spacing(2),
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        padding: theme.spacing(0),
        boxShadow: "0 0 0 0"
    },
    tabs: {
        marginBottom: theme.spacing(4)
    },
    avatar: {
        margin: theme.spacing(1),
        backgroundColor: theme.palette.secondary.main,
    },
}));

function Payment({ selectedPlan, setView, setClose }) {
    const classes = useStyles()
    const [tab, setTab] = useState(0);
    
    useEffect(() => {
        if (!selectedPlan.id) {
            setView(1)
        }
    }, []);

    const handleChange = (event, newValue) => {
        setTab(newValue);
    };

    return (
        <Grid container justifyContent="center">
            <Grid item xs={12}>
                <Paper square className={classes.paper}>
                    <Avatar className={classes.avatar}>
                        <LockOutlinedIcon />
                    </Avatar>
                    <Typography align="center" component="h1" variant="h4">
                        Payment Page
                    </Typography>
                    <Typography align="center" component="h1" color="textSecondary" variant="h6">
                    Every month, hundreds of new 2D, 3D characters and templates will be added. Just 3.99$ per month. Value for money. Choose any one of the payment method.
                    </Typography>

                    <Tabs
                        value={tab}
                        indicatorColor="secondary"
                        textColor="primary"
                        centered
                        className={classes.tabs}
                        onChange={handleChange}
                        aria-label="disabled tabs example"
                    >
                        <Tab label="PayPal" />
                        <Tab label="Google Pay" />
                        <Tab label="Card" />
                       
                    </Tabs>
                    {tab === 0 && <PayPal selectedPlan={selectedPlan} setClose={setClose} />}
                    {tab === 1 && <GooglePay selectedPlan={selectedPlan} setClose={setClose} />}
                    {tab === 2 && <StripePayment selectedPlan={selectedPlan} setClose={setClose} />}                    
                    {/*<Powered by={tab === 2 ? "PayPal" : "Stripe"} />*/}
                    <Powered/>
                </Paper>
            </Grid>
        </Grid>
    );
}

export default Payment